/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
bcl.s.form = {
  props: {
    classNameInputInvalid: "mod--invalidate",
    classNameInputValid: "mod--validate",
    classNameEmptyInvalid: "mod--active-message-empty",
    classNameErrorInvalid: "mod--active-message-error",
    classNameFormCheck: "formCheck",
    classErrorValidationForm: "errorValidationForm",
    buttonSendJS: "button-send-JS",
    classNameSuccessJS: "modal-success-JS",
    classNameErrorJS: "modal-error-JS",
    classNameErrorCodeJS: "modal-error-{code}-JS",
    errorCodePlaceholderToReplace: "{code}",
    utagEventForm: {
      "newsletter-form": "newsletterCallbackUtag",
      "service-contact-form": "serviceContactFormCallbackUtag",
    },
    inputErrorClass: "c-input-error-message",
    inputEmptyClass: "c-input-empty-message",
  },

  preInit: function () {
    bcl.u.docReady(bcl.s.form.init);
  },

  init: function (baseDom) {
    const baseFind = baseDom ? baseDom : document,
      $forms = baseFind.querySelectorAll("form");

    if (!$forms) {
      return;
    }

    bcl.u.forEach($forms, bcl.s.form.initForm);
  },

  initForm: function ($form) {
    const $inputs = $form.querySelectorAll("input, select, textarea, text, tel");

    if (!$inputs) {
      return;
    }

    bcl.u.forEach($inputs, function ($input) {
      bcl.s.form.initInput($input, $form);
    });

    const $button = $form.querySelector("." + bcl.s.form.props.buttonSendJS);

    $button?.addEventListener("click", function () {
      bcl.u.addClass($form, bcl.s.form.props.classNameFormCheck);
      bcl.s.form.checkForm($form);
    });
  },

  initInput: function ($input, $form) {
    $input.addEventListener("change", function () {
      bcl.s.form.inputTypeValidity($input, $form);
    });

    bcl.s.form.formsToggle.init($input, $form);

    if ($form.dataset.text && $input.type !== "hidden" && $input.type == "radio") {
      bcl.u.addClass($input.parentNode.parentNode.firstElementChild, "radio-error");
      bcl.s.form.initErrorMessage($input.parentNode.parentNode.firstElementChild.firstElementChild, $form);
    } else if ($form.dataset.text && $input.type !== "hidden") {
      bcl.s.form.initErrorMessage($input, $form);
    }
  },

  initErrorMessage: function ($input, $form) {
    if ($input.parentNode.getElementsByClassName(bcl.s.form.props.inputErrorClass).length < 1) {
      bcl.s.form.insertErrorMessage($input, $form, bcl.s.form.props.inputErrorClass, $input.dataset.texterror || $form.dataset.texterror);
    }
    if ($input.parentNode.getElementsByClassName(bcl.s.form.props.inputEmptyClass).length < 1) {
      bcl.s.form.insertErrorMessage($input, $form, bcl.s.form.props.inputEmptyClass, $input.dataset.textempty || $form.dataset.textempty);
    }
  },

  insertErrorMessage: function ($input, $form, classToInsert, messageValue) {
    const messageDiv = bcl.s.form.buildErrorDiv("div", classToInsert);

    messageDiv.innerHTML = messageValue || "";

    $input.parentNode.appendChild(messageDiv);
  },

  buildErrorDiv: function ($element, $class) {
    const errorDiv = document.createElement($element);

    bcl.u.addClass(errorDiv, $class);

    return errorDiv;
  },

  clickSend: function ($form) {
    const serialize = bcl.u.serializeForm($form),
      url = $form.dataset.url;

    if (!serialize || !url) {
      return;
    }

    bcl.u.addSpinner($form);

    if ($form.getAttribute("name") == "newsletter-form" && $form.dataset.sendTealium && !$form.dataset.sendEmail) {
      bcl.s.form.loadUtagEvent($form, serialize);
    } else {
      bcl.ajax.postRequest({
        data: serialize,
        url: url,
        callback: bcl.s.form.loadSend,
        itemCallback: {
          $form: $form,
          serialize: serialize,
        },
      });
    }
  },

  loadUtagEvent: function ($form, serialize) {
    bcl.u.removeSpinner($form);
    bcl.s.form.response(true, $form);

    const callback = bcl.s.form.props.utagEventForm[$form.getAttribute("name")];

    if (callback && bcl.s.form[callback] && bcl.u.utag.isEnabled()) {
      bcl.s.form[callback](null, $form, serialize);
    }
  },

  loadSend: function (response, obj) {
    const $form = obj.$form,
      serialize = obj.serialize;

    bcl.u.removeSpinner($form);
    bcl.s.form.processResponse(response, $form);

    if ($form.getAttribute("name") == "newsletter-form" && !$form.dataset.sendTealium) {
      return;
    }

    const callback = bcl.s.form.props.utagEventForm[$form.getAttribute("name")];

    if (callback && bcl.s.form[callback] && bcl.u.utag.isEnabled()) {
      bcl.s.form[callback](response, $form, serialize);
    }
  },

  processResponse: function (response, $form) {
    bcl.modal.close();

    if (!$form || !response || !response.response) {
      bcl.s.form.response(false, $form);
      return;
    }

    let obj;

    try {
      obj = JSON.parse(response.response);
    } catch (e) {
      console.error("Data error", response);
      console.error(e);
    }

    if (!obj) {
      bcl.s.form.response(false, $form);
      return;
    }

    bcl.s.form.response(obj.success, $form, obj.errorCode);
  },

  response: function (success, $form, errorCode) {
    let className = "classNameSuccessJS";
    const classNameError = "classNameErrorJS";

    if (!success && errorCode) {
      className = "classNameErrorCodeJS";
    } else if (!success) {
      className = "classNameErrorJS";
    } else {
      bcl.s.form.clear($form);
    }

    let selector = "." + bcl.s.form.props[className];

    if (!success && errorCode) {
      const newSelector = selector.replace(bcl.s.form.props["errorCodePlaceholderToReplace"], errorCode);
      const $b = $form.querySelector(newSelector);

      if ($b) {
        bcl.u.triggerEvent($b, "click");
        return;
      }

      selector = "." + bcl.s.form.props[classNameError];
    }

    const $a = $form.querySelector(selector);

    if ($a) {
      bcl.u.triggerEvent($a, "click");
    }
  },

  clear: function ($form) {
    const $inputs = $form.querySelectorAll("input, select, textarea");

    if (!$inputs) {
      return;
    }

    $form.reset();

    bcl.u.forEach($inputs, function ($input) {
      if ($input.type === "hidden") {
        $input.value = "";
      }
      bcl.u.removeClass($input, bcl.s.form.props.classNameInputInvalid);
      bcl.u.removeClass($input, bcl.s.form.props.classNameInputValid);
      if (bcl.u.containsClass($input, "flatpickr")) {
        const inputId = $input.parentNode.children[1].id;
        bcl.s.flatpickr.props.instances[inputId]?.clear();
        if (bcl.u.containsClass($input, bcl.s.form.props.classNameInputInvalid)) {
          bcl.u.removeClass($input, bcl.s.form.props.classNameInputInvalid);
        }
      }
    });

    bcl.u.removeClass($form, bcl.s.form.props.classNameFormCheck);
  },

  newsletterCallbackUtag: function (response, $form, serialize) {
    try {
      const obj = {
        user_email: serialize["contact-mail"],
        email_field_2: serialize["emailField2"],
        user_name: serialize["contact-name"],
        user_surname: serialize["contact-surname"],
        text_field_3: serialize["textField3"],
        text_field_4: serialize["textField4"],
        user_phone: serialize["contact-tel"],
        user_birthday: serialize["contact-birth"],
        user_suscription_type: $form.dataset.tealiumUserSubcriptionType,
        event_category: $form.dataset.tealiumEventCategory,
        event_action: $form.dataset.tealiumEventAction,

        event_label: window.utag_data.pagecategorization,
        tealium_event: $form.dataset.tealiumEvent,
      };

      bcl.u.utag.push(obj);
    } catch (e) {
      console.error("Event push error", e);
    }
  },

  serviceContactFormCallbackUtag: function (response, $form, serialize) {
    let label = window.utag_data.hotel_id;
    const $node = document.querySelector(".c-header-detail__nav-title");

    if ($node) {
      let text = $node.innerText;

      text = text.replace(/[\'\"]/gi, "");

      label += "-" + text.toLowerCase();
    }

    try {
      const obj = {
        user_email: serialize["contact-mail"],
        user_name: serialize["contact-name"],
        user_phone: serialize["contact-tel"],
        user_suscription_type: "experiences",
        event_category: "subscriptions",
        event_action: "experiences",
        event_label: label,
        "tealium event": "experiences",
      };

      bcl.u.utag.push(obj);
    } catch (e) {
      console.error("Event push error", e);
    }
  },

  checkForm: function ($form) {
    bcl.u.removeClass($form, bcl.s.form.props.classErrorValidationForm);

    const $inputs = $form.querySelectorAll("input, select, textarea");
    let statusForm = true;

    bcl.s.form.checkAlmostOne($form);

    bcl.u.forEach($inputs, function ($input) {
      let preStatus = true;

      if ($form.name && $form.name == "form-reservation-m") {
        preStatus = bcl.s.form.formReservationMValidity($input, $form);
      } else if ($form.name && $form.name == "form-reservation-c") {
        preStatus = bcl.s.form.formReservationCValidity($input, $form);
      } else if ($form.name && $form.name == "form-claim-s") {
        preStatus = bcl.s.form.formClaimSValidity($input, $form);
      } else {
        preStatus = bcl.s.form.inputTypeValidity($input, $form);
      }

      if (statusForm) {
        statusForm = preStatus;
      }
    });

    if (!statusForm) {
      bcl.u.addClass($form, bcl.s.form.props.classNameFormCheck);
      bcl.u.addClass($form, bcl.s.form.props.classErrorValidationForm);
    } else {
      bcl.u.removeClass($form, bcl.s.form.props.classErrorValidationForm);
    }
  },
};

bcl.preInit.push(bcl.s.form.preInit);
